<template>
	<vue-tel-input
		:value="input"
		@input="(text, object) => phoneChanged(object)"
		class="form-input"
		:defaultCountry="item.countryPrefix"
		:placeholder="$t('form.phone-placeholder')"
		:required="item.required == 1"
		:style="inputStyle"
		validCharactersOnly
	></vue-tel-input>
</template>

<script>
/**
 * vue-tel-input will automatically do request to ip2c.org to determine current country and set it as default flag.
 * Adblockers will block these request to ip2c.org which defaults to Afghanistan.
 */
import { VueTelInput } from "vue-tel-input";

export default {
	name: "PhoneInput",
	props: ["value", "item", "inputStyle"],
	components: {
		VueTelInput,
	},
	data() {
		return {
			input: this.value,
		};
	},
	methods: {
		phoneChanged(object) {
			// We can not check object.number.input as this one always has the prefix when deleting the input
			// object.number.e164 can be used instead as this property doesn't exist when we delete our input
			if (object.number.e164 == undefined) {
				this.$emit("object", null);
				this.$emit("input", null);
			} else {
				this.$emit("object", object);
				this.$emit("input", object.number.e164);
			}
		},
	},
	watch: {
		value: function () {
			this.input = this.value ? this.value : "";
		},
	},
};
</script>

<style>
.vue-tel-input {
	display: inline-flex !important;
}

.vue-tel-input:focus,
.vue-tel-input:focus-within {
	outline: none !important;
	box-shadow: none !important;
}

/* Force black text for dropdown */
.vti__dropdown-item {
	color: black !important;
}

.vue-tel-input .vti__input {
	direction: inherit;
	padding-left: 0;
	padding-inline-start: 7px;
}
.vue-tel-input .vti__dropdown {
	direction: ltr;
}
</style>